import { CardProduct } from '@/shared/card/card-product/card-product';
import { PictureLazy } from '@/shared/common/picture/picture';

export function initSearchResults(container) {
	if (!container) return;

	container.querySelectorAll('picture.js-lazy').forEach((element) => {
		new PictureLazy(element);
	});

	container.querySelectorAll('.js-card-product').forEach((element) => {
		new CardProduct(element);
	});
}
